(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3767],{

/***/ 887546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PhoneIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function PhoneIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 21.111,
        height: props.size || 21.111,
        viewBox: "0 0 21.111 21.111"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19.417 13.857a11.986 11.986 0 01-3.764-.6 1.721 1.721 0 00-1.673.353l-2.374 1.79a13.118 13.118 0 01-5.9-5.9l1.741-2.307a1.706 1.706 0 00.42-1.729 12 12 0 01-.6-3.77A1.7 1.7 0 005.571 0H1.694A1.7 1.7 0 000 1.694a19.439 19.439 0 0019.417 19.417 1.7 1.7 0 001.694-1.694v-3.866a1.7 1.7 0 00-1.694-1.694z",
            fill: props.color
        })
    }));
}


/***/ }),

/***/ 293992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DigitalShowroomAds_ReasonModalHOC; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
;// CONCATENATED MODULE: ./src/utils/useClosePopupFromOutsideClick.js

function useClosePopupFromOutsideClick(referenceToDomElement, toggleClose, props) {
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        var ref;
        if (!((ref = e.composedPath()) === null || ref === void 0 ? void 0 : ref.includes(referenceToDomElement.current))) {
            e.stopPropagation();
            toggleClose(props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.toggleStatus);
        }
    };
}
/* harmony default export */ var utils_useClosePopupFromOutsideClick = (useClosePopupFromOutsideClick);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModal.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n  width: 20px;\n  margin-left: ",
        "rem;\n  transform: rotateZ(180deg);\n  margin-top: ",
        "rem;\n  box-shadow: 0px -6px 12px 2px rgb(0 0 0 / 30%);\n  ",
        ";\n\n  &:before {\n    content: '';\n    border-top: 10px solid white;\n    border-right: 10px solid transparent;\n    border-left: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PointingArrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PointingArrow",
    componentId: "sc-6444d3ae-0"
})(_templateObject(), function(props) {
    return props.ml || 0;
}, function(props) {
    return props.mt || 0;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.translateX) && (props === null || props === void 0 ? void 0 : props.translateY) && "transform : translate(".concat(props === null || props === void 0 ? void 0 : props.translateX, "rem , ").concat(props === null || props === void 0 ? void 0 : props.translateY, "rem) rotate(180deg)");
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js





function ReasonModalHOC(props) {
    var elementReferenceForOutsideClick = (0,react.useRef)();
    var closePopupForParticularId = {
        id: props.id,
        toggleStatus: false
    };
    utils_useClosePopupFromOutsideClick(elementReferenceForOutsideClick, props.toggleAdReasonModal, closePopupForParticularId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PointingArrow, {
                ml: props.ml,
                translateX: props.translateX,
                translateY: props.translateY,
                mt: props.mt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    zIndex: 1
                },
                ref: elementReferenceForOutsideClick,
                className: props.class,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(props.reasonModal, {})
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_ReasonModalHOC = (ReasonModalHOC);


/***/ }),

/***/ 913767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Footers/Footer/Footer.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  width: 100%;\n  border-top: 1px solid #e2e2e2;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  flex: 1 1 auto;\n  margin: 0 auto;\n\n  @media screen and (max-width: 766px) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin: 0 auto;\n  padding: ",
        ";\n  width: 100%;\n  justify-content: space-between;\n  max-width: ",
        ";\n\n  & > div {\n    display: block;\n    ",
        "\n  }\n\n  & > div::nth-of-type(1),\n  & > div::nth-of-type(3) {\n    flex-grow: 2;\n    flex-shrink: 2;\n  }\n\n  & > div::nth-of-type(2) {\n    flex-grow: 1;\n    flex-shrink: 1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (min-width: 767px) {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100%;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 20px;\n\n  @media screen and (min-width: 767px) {\n    align-items: center;\n  }\n\n  @media screen and (max-width: 766px) {\n    flex-direction: column;\n    gap: 20px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-position: center center;\n  object-fit: cover;\n\n  & > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  @media screen and (min-width: 767px) {\n    margin-right: 15px;\n    flex: 0 0 80px;\n    width: 80px;\n    height: 80px;\n  }\n\n  @media screen and (max-width: 766px) {\n    flex: 0 0 55px;\n    width: 55px;\n    height: 55px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  flex: 1;\n  color: #000000;\n  text-transform: uppercase;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media screen and (min-width: 767px) {\n    font-size: 24px;\n    -webkit-line-clamp: 3;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 21px;\n    -webkit-line-clamp: 4;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 766px) {\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  letter-spacing: 0.37px;\n  color: #000000;\n  margin: 0;\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 11px;\n    margin-bottom: 5px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #747373;\n  letter-spacing: 1.4px;\n  max-width: 300px;\n  margin: 0;\n  word-break: break-word;\n\n  ",
        "\n\n  ",
        "\n\n  @media screen and (min-width: 767px) {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11px;\n  font-weight: 600;\n  position: relative;\n  display: inline-block;\n  color: #2a2a2a;\n  line-height: 1.4em;\n  cursor: pointer;\n  margin-top: 5px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media screen and (min-width: 767px) {\n    border-top: 1px solid #bebebe;\n    padding: 30px 0;\n  }\n\n  @media screen and (max-width: 766px) {\n    flex-direction: column;\n    padding: 10px 0;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  color: #bebebe;\n  padding: 10px;\n\n  & > a,\n  & > a:visited,\n  & > a:active,\n  & > a:visited {\n    color: inherit;\n  }\n\n  & > a:not(:hover) {\n    text-decoration: none;\n  }\n\n  @media screen and (min-width: 767px) {\n    font-size: 12px;\n    &:first-child {\n      border-right: 1.5px solid #bebebe;\n    }\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  position: relative;\n  background-color: #747373;\n  margin-left: 10px;\n  margin-right: 10px;\n  border-radius: 50%;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  margin: 0 0 20px;\n  ",
        "\n\n  & > a,\n  & > a:visited,\n  & > a:active,\n  & > a:visited {\n    color: inherit;\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0 0 auto;\n  width: fit-content;\n  position: relative;\n  padding: 6px 8px;\n  border-radius: ",
        ";\n  border-style: solid;\n  border-width: 0.4px;\n  border-color: ",
        ";\n  cursor: pointer;\n\n  & > a {\n    display: flex;\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: inline-block;\n  margin-left: 10px;\n\n  @media screen and (min-width: 767px) {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: relative;\n\n  @media screen and (min-width: 767px) {\n    &:not(:first-child) {\n      margin-left: 10px;\n    }\n  }\n\n  @media screen and (max-width: 766px) {\n    margin-left: 10px;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  text-transform: capitalize;\n\n  @media screen and (max-width: 766px) {\n    font-size: 9px;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  @media screen and (min-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 30px 20px 0px;\n  flex-direction: column;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}

var FooterContainer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    displayName: "FooterContainer",
    componentId: "sc-a611385d-0"
})(_templateObject());
var FooterDesktopContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FooterDesktopContainer",
    componentId: "sc-a611385d-1"
})(_templateObject1());
var FooterDesktopMain = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FooterDesktopMain",
    componentId: "sc-a611385d-2"
})(_templateObject2(), function(param) {
    var noAddress = param.noAddress;
    return noAddress ? "3rem 2rem 1.5rem" : "3rem 1rem 1.5rem";
}, function(param) {
    var noAddress = param.noAddress;
    return noAddress ? "780px" : "1200px";
}, function(param) {
    var noAddress = param.noAddress;
    return noAddress ? "\n      flex: 0 0 auto\n    " : "width: 100%;";
});
var StoreDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreDescription",
    componentId: "sc-a611385d-3"
})(_templateObject3());
var StoreDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreDetails",
    componentId: "sc-a611385d-4"
})(_templateObject4(), function(param) {
    var noAddress = param.noAddress;
    return noAddress ? "0 20px" : "0";
});
var StoreMapComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreMapComp",
    componentId: "sc-a611385d-5"
})(_templateObject5());
var StoreNameImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreNameImage",
    componentId: "sc-a611385d-6"
})(_templateObject6());
var StoreImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreImage",
    componentId: "sc-a611385d-7"
})(_templateObject7());
var StoreName = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "StoreName",
    componentId: "sc-a611385d-8"
})(_templateObject8());
var StoreAboutUs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StoreAboutUs",
    componentId: "sc-a611385d-9"
})(_templateObject9());
var FooterLabel = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "FooterLabel",
    componentId: "sc-a611385d-10"
})(_templateObject10());
var FooterPara = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "FooterPara",
    componentId: "sc-a611385d-11"
})(_templateObject11(), function(props) {
    return props.textSelection && "\n    -webkit-touch-callout: text;\n    -webkit-user-select: text;\n    -khtml-user-select: text;\n    -moz-user-select: text;\n    -ms-user-select: text;\n    user-select: text;  \n  ";
}, function(props) {
    return props.needLineClip && "\n    display: -webkit-box;\n    -webkit-line-clamp: 5;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ";
});
var ViewMoreText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ViewMoreText",
    componentId: "sc-a611385d-12"
})(_templateObject12());
var FooterTrademarkComponent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterTrademarkComponent",
    componentId: "sc-a611385d-13"
})(_templateObject13());
var FooterTrademark = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "FooterTrademark",
    componentId: "sc-a611385d-14"
})(_templateObject14());
var Circle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Circle",
    componentId: "sc-a611385d-15"
})(_templateObject15());
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Section",
    componentId: "sc-a611385d-16"
})(_templateObject16(), function(props) {
    return props.display || "block";
}, function(props) {
    return props.display && "\n    margin: 0; \n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    border-bottom: 1px solid #707070;\n  ";
});
var FooterButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FooterButton",
    componentId: "sc-a611385d-17"
})(_templateObject17(), function(props) {
    return props.theme.roundness || "14px";
}, function(props) {
    return props.color;
});
var PhoneNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PhoneNumber",
    componentId: "sc-a611385d-18"
})(_templateObject18(), function(props) {
    return props.color;
});
var PaymentRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PaymentRow",
    componentId: "sc-a611385d-19"
})(_templateObject19());
var PaymentOption = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PaymentOption",
    componentId: "sc-a611385d-20"
})(_templateObject20());
var PaymentCash = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PaymentCash",
    componentId: "sc-a611385d-21"
})(_templateObject21());
var FooterMobileContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "FooterMobileContainer",
    componentId: "sc-a611385d-22"
})(_templateObject22());
var FooterMobileMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterMobileMain",
    componentId: "sc-a611385d-23"
})(_templateObject23());

// EXTERNAL MODULE: ./src/assets/svgExports/PhoneIcon.js
var PhoneIcon = __webpack_require__(887546);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(467313);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/deviceInfo.js
var deviceInfo = __webpack_require__(990864);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/components/DesignSystem/SubscriberInput/index.js + 1 modules
var SubscriberInput = __webpack_require__(156695);
// EXTERNAL MODULE: ./src/components/LogoutModal/index.js
var LogoutModal = __webpack_require__(821448);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/commonToggleAuthModal.js
var commonToggleAuthModal = __webpack_require__(13605);
// EXTERNAL MODULE: ./src/utils/removeDsAdsRouteLink.js
var removeDsAdsRouteLink = __webpack_require__(295218);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(385126);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/Hybrid.styles.js
var Hybrid_styles = __webpack_require__(343955);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/HorizontalReasonModal.js



function HorizontalReasonModal(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between flew-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-column justify-center items-center left-section ml20px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex left-section-text-body f12px fw6",
                    children: [
                        "You are seeing this Ad ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "because owner of this ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "website using the free",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "version"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-column justify-center items-start pt20px pl20px pr20px right-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex f12px fw6",
                        children: [
                            "If you own this website",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "then you can remove this"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex pa12px right-removead-section mt14px",
                        onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex fw7",
                            children: "Remove this Ad"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_HorizontalReasonModal = (HorizontalReasonModal);

// EXTERNAL MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js + 2 modules
var ReasonModalHOC = __webpack_require__(293992);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(336623);
// EXTERNAL MODULE: ./src/components/FooterMap/index.js + 2 modules
var FooterMap = __webpack_require__(176364);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/components/DesignSystem/Footers/FooterStorePolicies/index.js
var FooterStorePolicies = __webpack_require__(781059);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/components/DesignSystem/Footers/footerUtils.js
var footerUtils = __webpack_require__(362371);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/hooks/useStoreLogoOrNameVisibility.js
var useStoreLogoOrNameVisibility = __webpack_require__(273323);
// EXTERNAL MODULE: ./src/utils/getActualOrDsStoreLogo.js
var getActualOrDsStoreLogo = __webpack_require__(168491);
// EXTERNAL MODULE: ./src/utils/checkIfThemePreview.js
var checkIfThemePreview = __webpack_require__(115483);
// EXTERNAL MODULE: ./src/redux/actions/storePolicies.js
var actions_storePolicies = __webpack_require__(849784);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(299375);
// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(527941);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Footers/Footer/Footer.js

































var PremiumFooter = function(props) {
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var renderSocialMediaProfileDetails = function renderSocialMediaProfileDetails(isMobileView) {
        var ref, ref1, ref2;
        if (!((ref = store.social_media_profile_details) === null || ref === void 0 ? void 0 : ref.media_count) || ((ref1 = store.social_media_profile_details) === null || ref1 === void 0 ? void 0 : ref1.media_count) < 1) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "footer-social-media-container",
            style: isMobileView ? {} : {
                width: "246px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Follow us here"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "social-media-section flex space-between",
                    style: {
                        gap: "16px"
                    },
                    children: (ref2 = store.social_media_profile_details) === null || ref2 === void 0 ? void 0 : ref2.media_detail.map(function(profile) {
                        return profile.profile_url !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "social-media-icon",
                            style: {
                                height: "24px",
                                width: "24px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: profile.profile_url,
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: profile.image_url,
                                    alt: "".concat(profile === null || profile === void 0 ? void 0 : profile.name, " image"),
                                    loading: "lazy"
                                })
                            })
                        }, profile.id) : null;
                    })
                })
            ]
        });
    };
    var renderLoginLogoutDesktop = function renderLoginLogoutDesktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footer-login-logout",
                onClick: toggleAuthModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-login-logout-button fw5 pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontSize: 12
                        },
                        children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                    })
                })
            })
        });
    };
    var renderLoginLogoutMobile = function renderLoginLogoutMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footer-login-logout",
                onClick: toggleAuthModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-login-logout-button fw5 pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontSize: 12
                        },
                        children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                    })
                })
            })
        });
    };
    var authAndLogoutModal = function authAndLogoutModal() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: excuteLogout/* executeLogout */.q,
                showLogoutConfirmation: showLogoutConfirmation
            })
        });
    };
    var toggleAdReasonModal = function toggleAdReasonModal() {
        setShowAdInfo(!showAdInfo);
    };
    var renderDesktopAds = function renderDesktopAds() {
        var ref, ref1, ref2;
        return !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: deviceWidth/* deviceWidth */.o > constants/* MAX_MOBILE_WIDTH */.Cf && ((ref = store.store_info) === null || ref === void 0 ? void 0 : ref.non_premium_ad_url_desktop_horizontal) && !(store === null || store === void 0 ? void 0 : (ref1 = store.theme) === null || ref1 === void 0 ? void 0 : ref1.is_demo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* AdContainer */.g1, {
                paddingTop: 0,
                paddingBottom: 42,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-column digital-showroom__ads-footer items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex footer-ads___width",
                            onClick: function() {
                                return setShowAdInfo(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex f8px o-50 mb6px black-90 f14px pointer",
                                    children: "Why I am seeing this"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ml10px f10px pointer",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                                            size: 16,
                                            secondaryColor: "#7F7F7F"
                                        }),
                                        showAdInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonModalHOC/* default */.Z, {
                                            toggleAdReasonModal: toggleAdReasonModal,
                                            reasonModal: DigitalShowroomAds_HorizontalReasonModal,
                                            ml: -0.1,
                                            mt: -0.3,
                                            translateX: 0,
                                            translateY: 0,
                                            class: "horizontal-reason-modal mt8px"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex pointer items-start",
                            onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                unoptimized: true,
                                src: (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : ref2.non_premium_ad_url_desktop_horizontal,
                                width: 877,
                                height: 187,
                                loading: "lazy",
                                decoding: "async"
                            })
                        })
                    ]
                })
            }) : null
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var user = (0,es/* useSelector */.v9)(function(state) {
        return {
            user: state.userReducer
        };
    }).user;
    var ref6 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            store: state.storeReducer.store,
            storePolicies: state.storePolicyReducer.data
        };
    }), store = ref6.store, storePolicies = ref6.storePolicies;
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var ref7 = (0,useFeatureLocks/* useFeatureLocks */.r)(), leadGenFeatureStatus = ref7.leadGenFeatureStatus, visitorLoginFeatureStatus = ref7.visitorLoginFeatureStatus;
    var isLeadGenVisible = leadGenFeatureStatus === null || leadGenFeatureStatus === void 0 ? void 0 : leadGenFeatureStatus.isVisible;
    var isVisitorLoginVisible = visitorLoginFeatureStatus === null || visitorLoginFeatureStatus === void 0 ? void 0 : visitorLoginFeatureStatus.isVisible;
    var ref8 = (0,react.useState)(""), sColor = ref8[0], setColor = ref8[1];
    var ref9 = (0,react.useState)(false), isDesktop = ref9[0], setIsDesktop = ref9[1];
    var ref10 = (0,react.useState)(false), isLoaded = ref10[0], setIsLoaded = ref10[1];
    var ref11 = (0,react.useState)({
        OSName: null,
        ownerNumber: null
    }), state = ref11[0], setState = ref11[1];
    var ref12 = (0,react.useState)(null), fullYear = ref12[0], setFullYear = ref12[1];
    var ref13 = (0,react.useState)(false), showLogoutConfirmation = ref13[0], setShowLogoutConfirmation = ref13[1];
    var ref14 = (0,react.useState)(false), showAdInfo = ref14[0], setShowAdInfo = ref14[1];
    var isPreview = (0,checkIfThemePreview/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var thisYear = new Date();
        setFullYear(thisYear.getFullYear());
        var OSName = (0,deviceInfo/* getDeviceInfo */.d)().OSName;
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                OSName: OSName,
                ownerNumber: storePhone
            });
        });
    }, [
        store
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) {
            var ref2, ref3;
            setColor((store === null || store === void 0 ? void 0 : store.premium) ? store === null || store === void 0 ? void 0 : (ref2 = store.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#000000");
        }
    }, [
        store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color
    ]);
    (0,react.useEffect)(function() {
        if (deviceWidth/* deviceWidth */.o > 766) {
            setIsDesktop(true);
        } else {
            setIsDesktop(false);
        }
        setIsLoaded(true);
    }, [
        deviceWidth/* deviceWidth */.o > 0
    ]);
    (0,react.useEffect)(function() {
        setShowLogoutConfirmation(false);
    }, [
        user === null || user === void 0 ? void 0 : user.isLogin
    ]);
    (0,react.useEffect)(function() {
        if ((store === null || store === void 0 ? void 0 : store.store_id) && !(storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length)) {
            dispatch((0,actions_storePolicies/* getStorePolicies */.S)({
                store_id: store.store_id
            }));
        }
    }, [
        store === null || store === void 0 ? void 0 : store.store_id,
        storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length
    ]);
    var toggleAuthModal = function() {
        var ref;
        if ((0,commonToggleAuthModal/* commonToggleAuthModal */.D)({
            userLogin: user === null || user === void 0 ? void 0 : user.isLogin,
            storeInfoDomain: store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain
        })) toggleLogoutModal();
    };
    var callNumber = function(e) {
        if (!((state.OSName === "Android" || state.OSName === "iPhone") && deviceWidth/* deviceWidth */.o < 766)) {
            e.preventDefault();
        }
    };
    return isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContainer, {
        children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterDesktop, {
            callNumber: callNumber,
            authAndLogoutModal: authAndLogoutModal,
            renderLoginLogoutDesktop: renderLoginLogoutDesktop,
            renderDesktopAds: renderDesktopAds,
            router: router,
            noDescription: props.noDescription,
            store: store,
            sColor: sColor,
            fullYear: fullYear,
            renderSocialMediaProfileDetails: renderSocialMediaProfileDetails,
            storePolicies: storePolicies,
            showSubscriberInput: isLeadGenVisible,
            showVisitorLogin: isVisitorLoginVisible,
            isPaymentNotVisible: props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.hidden_components) === null || ref3 === void 0 ? void 0 : ref3.payment_method_images_not_visible
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMobile, {
            callNumber: callNumber,
            authAndLogoutModal: authAndLogoutModal,
            renderLoginLogoutMobile: renderLoginLogoutMobile,
            router: router,
            noDescription: props.noDescription,
            store: store,
            sColor: sColor,
            fullYear: fullYear,
            storePolicies: storePolicies,
            renderSocialMediaProfileDetails: renderSocialMediaProfileDetails,
            showSubscriberInput: isLeadGenVisible,
            showVisitorLogin: isVisitorLoginVisible,
            isPaymentNotVisible: props === null || props === void 0 ? void 0 : (ref4 = props.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.hidden_components) === null || ref5 === void 0 ? void 0 : ref5.payment_method_images_not_visible
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
};
var FooterDesktop = function(param) {
    var store = param.store, sColor = param.sColor, noDescription = param.noDescription, router = param.router, callNumber = param.callNumber, fullYear = param.fullYear, authAndLogoutModal = param.authAndLogoutModal, renderLoginLogoutDesktop = param.renderLoginLogoutDesktop, showVisitorLogin = param.showVisitorLogin, renderDesktopAds = param.renderDesktopAds, renderSocialMediaProfileDetails = param.renderSocialMediaProfileDetails, storePolicies = param.storePolicies, showSubscriberInput = param.showSubscriberInput, isPaymentNotVisible = param.isPaymentNotVisible;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    var dsLabel = (0,footerUtils/* getFooterDSLabel */.m)({
        configs: store === null || store === void 0 ? void 0 : store.configs,
        suffix: "APP",
        customStyles: {
            textTransform: "uppercase"
        }
    });
    var ref21 = (0,useStoreLogoOrNameVisibility/* default */.Z)(), isStoreLogoInFooter = ref21.isStoreLogoInFooter, isStoreNameInFooter = ref21.isStoreNameInFooter;
    var storeLogo = (0,getActualOrDsStoreLogo/* default */.Z)(store);
    var ref22 = (0,useStoreContactDetails/* default */.Z)(), storeAddress = ref22.storeAddress, storePhone = ref22.storePhone;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            authAndLogoutModal(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterDesktopContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterDesktopMain, {
                        noAddress: (store === null || store === void 0 ? void 0 : (ref = store.address) === null || ref === void 0 ? void 0 : ref.visibility) === 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreDescription, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreNameImage, {
                                        children: [
                                            storeLogo && isStoreLogoInFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreImage, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "store logo",
                                                    src: storeLogo
                                                })
                                            }),
                                            (store === null || store === void 0 ? void 0 : (ref1 = store.store_info) === null || ref1 === void 0 ? void 0 : ref1.name) && isStoreNameInFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName, {
                                                children: store === null || store === void 0 ? void 0 : (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : ref2.name
                                            })
                                        ]
                                    }),
                                    !noDescription && (store === null || store === void 0 ? void 0 : (ref3 = store.store_info) === null || ref3 === void 0 ? void 0 : ref3.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreAboutUs, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                children: "About Us"
                                            }),
                                            !!(store === null || store === void 0 ? void 0 : (ref4 = store.store_info) === null || ref4 === void 0 ? void 0 : ref4.description) && (store === null || store === void 0 ? void 0 : (ref5 = store.store_info) === null || ref5 === void 0 ? void 0 : ref5.description.length) > 160 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterPara, {
                                                textSelection: true,
                                                children: [
                                                    store === null || store === void 0 ? void 0 : (ref6 = store.store_info) === null || ref6 === void 0 ? void 0 : ref6.description.substr(0, 155),
                                                    "..."
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterPara, {
                                                textSelection: true,
                                                needLineClip: true,
                                                children: store === null || store === void 0 ? void 0 : (ref7 = store.store_info) === null || ref7 === void 0 ? void 0 : ref7.description
                                            }),
                                            (store === null || store === void 0 ? void 0 : (ref8 = store.store_info) === null || ref8 === void 0 ? void 0 : ref8.description.length) > 160 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreText, {
                                                onClick: function() {
                                                    var ref;
                                                    router.push((0,routes.getRoute)(routes.PATH.ABOUT_US, store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                                                },
                                                children: "View More"
                                            })
                                        ]
                                    }),
                                    showVisitorLogin && renderLoginLogoutDesktop()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreDetails, {
                                noAddress: (store === null || store === void 0 ? void 0 : (ref9 = store.address) === null || ref9 === void 0 ? void 0 : ref9.visibility) === 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                        children: storePhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                    children: "Contact us"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterButton, {
                                                    color: sColor || (store === null || store === void 0 ? void 0 : (ref10 = store.store_info) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.theme) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.colors) === null || ref12 === void 0 ? void 0 : ref12.primary_color),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: "tel:".concat(storePhone),
                                                        onClick: callNumber,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "footer-button-phone-icon",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon/* PhoneIcon */.q, {
                                                                    color: sColor || (store === null || store === void 0 ? void 0 : (ref13 = store.store_info) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.theme) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.colors) === null || ref15 === void 0 ? void 0 : ref15.primary_color),
                                                                    size: 12
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumber, {
                                                                color: sColor || (store === null || store === void 0 ? void 0 : (ref16 = store.store_info) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.theme) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.colors) === null || ref18 === void 0 ? void 0 : ref18.primary_color),
                                                                children: storePhone
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    showSubscriberInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriberInput/* default */.Z, {})
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                        children: storeAddress && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                    children: "Visit Us"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterPara, {
                                                    children: storeAddress
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                        children: (store === null || store === void 0 ? void 0 : store.social_media_profile_details) && renderSocialMediaProfileDetails(false)
                                    }),
                                    !isPaymentNotVisible && !(store === null || store === void 0 ? void 0 : (ref19 = store.services) === null || ref19 === void 0 ? void 0 : ref19.delivery_time_approx) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                                        style: {
                                            display: "none"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                children: (0,getCustomCtaText/* default */.Z)("pay_after_cta")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentRow, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                                            unoptimized: true,
                                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/TVi0GjBB.webp",
                                                            alt: "Paytm",
                                                            height: 31,
                                                            width: 63,
                                                            layout: "fixed",
                                                            loading: "lazy",
                                                            decoding: "async"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                                            unoptimized: true,
                                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/N2BcdtfG.webp",
                                                            alt: "GPay",
                                                            height: 27,
                                                            width: 57,
                                                            layout: "fixed",
                                                            loading: "lazy",
                                                            decoding: "async"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                                            unoptimized: true,
                                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/WZktEt3t.webp",
                                                            alt: "Phonpe",
                                                            height: 25,
                                                            width: 25,
                                                            layout: "fixed",
                                                            loading: "lazy",
                                                            decoding: "async"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCash, {
                                                            children: "Or Cash"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMap/* FooterMap */.sy, {
                                storeData: store
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStorePolicies/* FooterStorePolicies */.p, {
                        storePolicies: storePolicies,
                        path: routes.PATH.STORE_POLICIES
                    }),
                    renderDesktopAds(),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademarkComponent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademark, {
                                children: [
                                    "Copyright ",
                                    fullYear,
                                    dsLabel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            ". ",
                                            dsLabel
                                        ]
                                    }) : "",
                                    " | "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademark, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        href: constants/* CANCELATION_AND_REFUND_POLICY_URL */.a6,
                                        rel: "noreferrer",
                                        children: "Refunds & Cancellation"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {}),
                                    (store === null || store === void 0 ? void 0 : (ref20 = store.services) === null || ref20 === void 0 ? void 0 : ref20.delivery_time_approx) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        href: constants/* DS_TERMS_AND_CONDITIONS_URL */.gl,
                                        rel: "noreferrer",
                                        children: "Terms & Conditions"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        href: constants/* DS_TERMS_AND_CONDITIONS_URL */.gl,
                                        rel: "noreferrer",
                                        children: "Terms & Conditions"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var FooterMobile = function(param) {
    var store = param.store, sColor = param.sColor, noDescription = param.noDescription, router = param.router, callNumber = param.callNumber, fullYear = param.fullYear, authAndLogoutModal = param.authAndLogoutModal, renderLoginLogoutMobile = param.renderLoginLogoutMobile, showVisitorLogin = param.showVisitorLogin, renderSocialMediaProfileDetails = param.renderSocialMediaProfileDetails, storePolicies = param.storePolicies, showSubscriberInput = param.showSubscriberInput, isPaymentNotVisible = param.isPaymentNotVisible;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var dsLabel = (0,footerUtils/* getFooterDSLabel */.m)({
        configs: store === null || store === void 0 ? void 0 : store.configs,
        suffix: "APP",
        customStyles: {
            textTransform: "uppercase"
        }
    });
    var ref19 = (0,useStoreLogoOrNameVisibility/* default */.Z)(), isStoreLogoInFooter = ref19.isStoreLogoInFooter, isStoreNameInFooter = ref19.isStoreNameInFooter;
    var storeLogo = (0,getActualOrDsStoreLogo/* default */.Z)(store);
    var ref20 = (0,useStoreContactDetails/* default */.Z)(), storeAddress = ref20.storeAddress, storePhone = ref20.storePhone;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            authAndLogoutModal(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterMobileContainer, {
                children: [
                    !isPaymentNotVisible && !(store === null || store === void 0 ? void 0 : (ref = store.services) === null || ref === void 0 ? void 0 : ref.delivery_time_approx) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        display: "flex",
                        style: {
                            display: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                style: {
                                    flex: 0.9
                                },
                                children: (0,getCustomCtaText/* default */.Z)("pay_after_cta")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentRow, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                            unoptimized: true,
                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/TVi0GjBB.webp",
                                            alt: "Paytm",
                                            height: 31,
                                            width: 63,
                                            layout: "fixed",
                                            loading: "lazy",
                                            decoding: "async"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                            unoptimized: true,
                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/N2BcdtfG.webp",
                                            alt: "GPay",
                                            height: 27,
                                            width: 57,
                                            layout: "fixed",
                                            loading: "lazy",
                                            decoding: "async"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                            unoptimized: true,
                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/WZktEt3t.webp",
                                            alt: "Phonpe",
                                            height: 25,
                                            width: 25,
                                            layout: "fixed",
                                            loading: "lazy",
                                            decoding: "async"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCash, {
                                            children: "Or Cash"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterMobileMain, {
                        children: [
                            showSubscriberInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriberInput/* default */.Z, {})
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreDescription, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreNameImage, {
                                        children: [
                                            storeLogo && isStoreLogoInFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreImage, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    loading: "lazy",
                                                    alt: "Store Logo",
                                                    src: storeLogo
                                                })
                                            }),
                                            (store === null || store === void 0 ? void 0 : (ref1 = store.store_info) === null || ref1 === void 0 ? void 0 : ref1.name) && isStoreNameInFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName, {
                                                children: store === null || store === void 0 ? void 0 : (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : ref2.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                                        children: [
                                            showVisitorLogin && renderLoginLogoutMobile(),
                                            storePhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                        children: "Contact us"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterButton, {
                                                        color: sColor || (store === null || store === void 0 ? void 0 : (ref3 = store.store_info) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.theme) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.colors) === null || ref5 === void 0 ? void 0 : ref5.primary_color),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            href: "tel:".concat(storePhone),
                                                            onClick: callNumber,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "footer-button-phone-icon",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon/* PhoneIcon */.q, {
                                                                        size: 11,
                                                                        color: sColor || (store === null || store === void 0 ? void 0 : (ref6 = store.store_info) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumber, {
                                                                    color: sColor || (store === null || store === void 0 ? void 0 : (ref9 = store.store_info) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.theme) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.colors) === null || ref11 === void 0 ? void 0 : ref11.primary_color),
                                                                    children: storePhone
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !noDescription && (store === null || store === void 0 ? void 0 : (ref12 = store.store_info) === null || ref12 === void 0 ? void 0 : ref12.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreAboutUs, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                children: "About Us"
                                            }),
                                            (store === null || store === void 0 ? void 0 : (ref13 = store.store_info) === null || ref13 === void 0 ? void 0 : ref13.description) && (store === null || store === void 0 ? void 0 : (ref14 = store.store_info) === null || ref14 === void 0 ? void 0 : ref14.description.length) > 160 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterPara, {
                                                textSelection: true,
                                                children: [
                                                    store === null || store === void 0 ? void 0 : (ref15 = store.store_info) === null || ref15 === void 0 ? void 0 : ref15.description.substr(0, 155),
                                                    "..."
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterPara, {
                                                textSelection: true,
                                                needLineClip: true,
                                                children: store === null || store === void 0 ? void 0 : (ref16 = store.store_info) === null || ref16 === void 0 ? void 0 : ref16.description
                                            }),
                                            (store === null || store === void 0 ? void 0 : (ref17 = store.store_info) === null || ref17 === void 0 ? void 0 : ref17.description.length) > 160 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreText, {
                                                onClick: function() {
                                                    var ref;
                                                    router.push((0,routes.getRoute)(routes.PATH.ABOUT_US, store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                                                },
                                                children: "View More"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                        children: (store === null || store === void 0 ? void 0 : store.social_media_profile_details) && renderSocialMediaProfileDetails(true)
                                    })
                                ]
                            }),
                            !!storeAddress && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDetails, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLabel, {
                                                    children: "Visit Us"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterPara, {
                                                    children: storeAddress
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMap/* FooterMap */.sy, {
                                        storeData: store
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStorePolicies/* FooterStorePolicies */.p, {
                        storePolicies: storePolicies,
                        path: routes.PATH.STORE_POLICIES
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademarkComponent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademark, {
                                children: [
                                    "Copyright ",
                                    fullYear,
                                    dsLabel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            ". ",
                                            dsLabel
                                        ]
                                    }) : ""
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterTrademark, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: constants/* CANCELATION_AND_REFUND_POLICY_URL */.a6,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Refunds & Cancellation"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {}),
                                    (store === null || store === void 0 ? void 0 : (ref18 = store.services) === null || ref18 === void 0 ? void 0 : ref18.delivery_time_approx) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: constants/* DS_TERMS_AND_CONDITIONS_URL */.gl,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Terms & Conditions"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: constants/* DS_TERMS_AND_CONDITIONS_URL */.gl,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Terms & Conditions"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer = (PremiumFooter);


/***/ }),

/***/ 781059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ FooterStorePolicies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186438);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27909);




var FooterStorePolicies = function(props) {
    return !props.storePolicies || props.storePolicies.length == 0 ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bottom_section), " flex flex-column items-center"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().store_policies), " flex justify-around w-100 f6"),
            children: props === null || props === void 0 ? void 0 : props.storePolicies.map(function(page) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    name: "page".concat(page.page_type),
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer_nav),
                    onClick: function() {
                        return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_2__/* .handleRouteChangesOnClick */ .Z)(props === null || props === void 0 ? void 0 : props.path, {
                            page_type: page.page_type
                        });
                    },
                    children: page.page_name
                }, page.id);
            })
        })
    });
};


/***/ }),

/***/ 362371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getFooterDSLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(693967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var getFooterDSLabel = function(param) {
    var configs = param.configs, _prefix = param.prefix, prefix = _prefix === void 0 ? "" : _prefix, _suffix = param.suffix, suffix = _suffix === void 0 ? "" : _suffix, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? {} : _customStyles;
    var ref;
    var showDsLabel = !!((ref = configs === null || configs === void 0 ? void 0 : configs.ds_branding_flag) !== null && ref !== void 0 ? ref : 1);
    if (showDsLabel) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                prefix ? "".concat(prefix, " powered") : "Powered",
                " by \xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: "https://download.digitalshowroom.app/download-cfe",
                    target: "_blank",
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("underline copyright-text-grey-color tw-cursor-pointer", customClasses),
                    rel: "website app link noreferrer",
                    style: customStyles,
                    children: [
                        "Digital Showroom ",
                        suffix
                    ]
                })
            ]
        });
    }
    return null;
};


/***/ }),

/***/ 343955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ListingHeading; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "Z5": function() { return /* binding */ AllCategorySection; },
/* harmony export */   "bu": function() { return /* binding */ AllCategoryButton; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "rV": function() { return /* binding */ MiddleBodyAdWrapper; }
/* harmony export */ });
/* unused harmony export Listing */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(307297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(150066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  width: ",
        ";\n  display: flex;\n  max-width: 1600px;\n  flex-direction: column;\n  height: auto;\n  box-sizing: border-box;\n  position: relative;\n  margin: 0 auto;\n  ",
        "\n  @media screen and (max-width: 767px) {\n    padding-top: 0;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  width: 100%;\n  font-size: 40px;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 40px;\n    margin-bottom: 3rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 28px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  display: grid;\n  grid-template-rows: auto;\n  justify-items: center;\n  box-sizing: border-box;\n  margin-bottom: 3rem;\n\n  @media screen and (min-width: 767px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    row-gap: 2rem;\n    column-gap: 1.5rem;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    row-gap: 1.5rem;\n    column-gap: 1rem;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000000;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n\n  @media screen and (min-width: 767px) {\n    font-size: 28px;\n    padding: 0 0;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 20px;\n    padding: 0 20px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  position: sticky;\n  bottom: 5%;\n  z-index: 5;\n  background: transparent;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  border-radius: 30px;\n  box-shadow: 0px 16px 36px #0000004a;\n  background: ",
        " 0% 0% no-repeat padding-box;\n  color: ",
        ";\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n    padding: 16px 40px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    padding: 14px 16px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-column-start: 1;\n  grid-column-end: 3;\n  background: ",
        ";\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  background: #fff;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

function slideInAnimate() {
    return "\n    animation-name: slide-in;\n    animation-duration: 0.5s;\n    transform : translateX(50px);\n\n    @keyframes slide-in {\n      from {\n          transform : translateX(0px);\n      }\n      to {\n          transform : translateX(50px);\n      }\n    }\n    ";
}
function slideOutAnimate(trasnlationDist) {
    return "\n    animation-name: slide-out;\n    animation-duration: 0.50s;\n\n    @keyframes slide-out {\n      from {\n          transform : translateX(50px);\n      }\n      to {\n        transform : translateX(-".concat(trasnlationDist - 50, "px);\n      }\n    }\n    ");
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "Container",
    componentId: "sc-81fe99c9-0"
})(_templateObject(), function(props) {
    return props.isBuilderMobile ? "4rem 16px 2rem" : "4rem 0 2rem";
}, function(props) {
    return props.isBuilderMobile ? "100%" : "80%";
}, function(props) {
    return props.showFilterDrawer === null ? "" : props.showFilterDrawer ? slideInAnimate() : slideOutAnimate(props.trasnlationDist);
});
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    displayName: "Heading",
    componentId: "sc-81fe99c9-1"
})(_templateObject1(), function(props) {
    return props.fontColor || "#000000";
});
var Listing = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Listing",
    componentId: "sc-81fe99c9-2"
})(_templateObject2());
var ListingHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    displayName: "ListingHeading",
    componentId: "sc-81fe99c9-3"
})(_templateObject3());
var AllCategorySection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategorySection",
    componentId: "sc-81fe99c9-4"
})(_templateObject4());
var AllCategoryButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategoryButton",
    componentId: "sc-81fe99c9-5"
})(_templateObject5(), function(props) {
    return props.backgroundColor || "#ffffff";
}, function(props) {
    return props.backgroundColor ? "#ffffff" : "#000000";
});
var AdContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AdContainer",
    componentId: "sc-81fe99c9-6"
})(_templateObject6(), function(props) {
    return props.backgroundColor || "#FFFFFF";
}, function(props) {
    return props.paddingTop || 0;
}, function(props) {
    return props.paddingBottom || 0;
});
var MiddleBodyAdWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MiddleBodyAdWrapper",
    componentId: "sc-81fe99c9-7"
})(_templateObject7());


/***/ }),

/***/ 527941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ NextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(425675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/NextImage.tsx
// import React, { useState } from 'react';
// import Image, { ImageProps } from 'next/image';
// /* --- shimmer helpers --- */
// const toBase64 = (str: string) =>
//   typeof window === 'undefined' ? Buffer.from(str).toString('base64') : window.btoa(str);
// const shimmer = (w = 700, h = 475) => `
// <svg width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
//   <defs>
//     <linearGradient id="g">
//       <stop stop-color="#f6f7f8" offset="0%" />
//       <stop stop-color="#eaeaea" offset="50%" />
//       <stop stop-color="#f6f7f8" offset="100%" />
//     </linearGradient>
//   </defs>
//   <rect width="${w}" height="${h}" fill="#f6f7f8"/>
//   <rect id="r" width="${w}" height="${h}" fill="url(#g)">
//     <animateTransform attributeName="transform" attributeType="XML"
//       type="translate" from="-${w} 0" to="${w} 0" dur="1s" repeatCount="indefinite" />
//   </rect>
// </svg>`;
// const shimmerDataURL = (w?: number, h?: number) =>
//   `data:image/svg+xml;base64,${toBase64(shimmer(w ?? 700, h ?? 475))}`;
// /* --- typed props like your original component --- */
// type TNextImage<T extends boolean = false> = T extends true
//   ? { useDefaultHTMLTag: true } & React.ImgHTMLAttributes<HTMLImageElement>
//   : { useDefaultHTMLTag?: false } & ImageProps;
// /* --- main component --- */
// export default function NextImage<T extends boolean = false>(props: TNextImage<T>) {
//   const [normalImageLoaded, setNormalImageLoaded] = useState(false);
//   const [loaded, setLoaded] = useState(false);
//   // native <img> mode
//   if ((props as any).useDefaultHTMLTag) {
//     const {
//       onLoad,
//       style,
//       width = '100%',
//       height = '100%',
//       ...rest
//     } = props as any;
//     const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
//       setNormalImageLoaded(true);
//       if (onLoad) onLoad(e);
//     };
//     // ensure wrapper reserves space; if width/height provided use them, fallback to a default height
//     const wrapperStyle: React.CSSProperties = {
//       display: 'inline-block',
//       position: 'relative',
//       overflow: 'hidden',
//       width: width ? (typeof width === 'number' ? `${width}px` : width) : undefined,
//       height: height ? (typeof height === 'number' ? `${height}px` : height) : undefined,
//       backgroundImage: !normalImageLoaded ? `url("${shimmerDataURL(16, 9)}")` : undefined,
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       ...((style as React.CSSProperties) || {}),
//     };
//     return (
//       <span style={wrapperStyle}>
//         <img
//           {...(rest as React.ImgHTMLAttributes<HTMLImageElement>)}
//           onLoad={handleLoad}
//         />
//       </span>
//     );
//   }
//   // next/image mode
//   const nextProps = props as ImageProps;
//   const { width, height, onLoadingComplete, style } = nextProps as any;
//   // compute small blurDataURL from shimmer (you can also pass a custom blurDataURL prop)
//   const blurData = shimmerDataURL(
//     typeof width === 'number' ? width : 700,
//     typeof height === 'number' ? height : 475
//   );
//   // wrapper ensures a placeholder background while the image is loading
//   const wrapperStyle: React.CSSProperties = {
//     position: nextProps.layout === 'fill' ? 'absolute' : 'relative',
//     display: 'block',
//     width:
//       nextProps.layout === 'fill'
//         ? '100%'
//         : width
//           ? typeof width === 'number'
//             ? `${width}px`
//             : width
//           : undefined,
//     height:
//       nextProps.layout === 'fill'
//         ? '100%'
//         : height
//           ? typeof height === 'number'
//             ? `${height}px`
//             : height
//           : undefined,
//     backgroundImage: !loaded ? `url("${blurData}")` : undefined,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center',
//     ...((style as React.CSSProperties) || {}),
//   };
//   return (
//     <div style={wrapperStyle}>
//       <Image
//         {...nextProps}
//         // keep placeholder prop so Next shows blur if it can, but we also have wrapper background as fallback
//         placeholder="blur"
//         blurDataURL={blurData}
//         onLoadingComplete={(res) => {
//           setLoaded(true);
//           if (onLoadingComplete) onLoadingComplete(res);
//         }}
//       />
//     </div>
//   );
// }





function NextImage(props) {
    if (props.useDefaultHTMLTag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        unoptimized: true
    }));
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/index.ts



/***/ }),

/***/ 156695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DesignSystem_SubscriberInput; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/redux/actions/leadgen.js
var leadgen = __webpack_require__(900171);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/assets/svgExports/ForwardArrow.js

var ForwardArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16.031",
        height: "16.031",
        viewBox: "0 0 16.031 16.031",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Path_49",
            "data-name": "Path 49",
            d: "M-3.984-12.984H-16.172l5.578-5.625L-12-20.016-20.016-12-12-3.984l1.406-1.406-5.578-5.625H-3.984Z",
            transform: "translate(-3.984 -3.984) rotate(180)",
            fill: "#fff"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/localStorageFunctions.js
var localStorageFunctions = __webpack_require__(174943);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/validateEmailError.js
var validateEmailError = __webpack_require__(695288);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(299375);
;// CONCATENATED MODULE: ./src/components/DesignSystem/SubscriberInput/index.js










var SubscriberInput = function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,es/* useSelector */.v9)(function(state) {
        return {
            store: state.storeReducer.store,
            leadgenInfo: state.leadGenReducer.leadgenInfo,
            userData: state.userReducer.data
        };
    }), leadgenInfo = ref5.leadgenInfo, userData = ref5.userData, store = ref5.store;
    var ref6 = (0,react.useState)(""), sColor = ref6[0], setColor = ref6[1];
    var ref7 = (0,react.useState)(""), leadInput = ref7[0], setLeadInput = ref7[1];
    var ref8 = (0,react.useState)(false), leadError = ref8[0], setLeadError = ref8[1];
    var ref9 = (0,react.useState)(false), isSubmitInTransit = ref9[0], setIsSubmitInTransit = ref9[1];
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) {
            var ref2, ref3;
            setColor((store === null || store === void 0 ? void 0 : store.premium) ? store === null || store === void 0 ? void 0 : (ref2 = store.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#000000");
        }
    }, [
        store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color
    ]);
    var handleLeadInput = function(e) {
        var ref;
        var value = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        if ((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.PHONE */.hm.PHONE && value.length <= 10 || (leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL) setLeadInput(value);
    };
    var submitLeadInput = function() {
        setIsSubmitInTransit(true);
        var phoneReg = /(6|7|8|9)\d{9}/;
        var emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var payload = {
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            lead_user_phone: "",
            lead_email_id: "",
            user_phone: userData === null || userData === void 0 ? void 0 : userData.phone
        };
        if ((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.PHONE */.hm.PHONE) payload["lead_user_phone"] = leadInput;
        else payload["lead_email_id"] = leadInput;
        if (payload["lead_email_id"]) {
            var status = (0,validateEmailError/* validateEmailError */.n)(payload["lead_email_id"]);
            if (!status) {
                return;
            }
        }
        var callback = function() {
            (0,Toast/* toastNotifySuccess */.jh)("Thanks for subscribing!");
            (0,localStorageFunctions/* setLeadData */.co)(leadInput);
            setLeadInput("");
            setTimeout(function() {
                return setIsSubmitInTransit(false);
            }, 500);
        };
        if ((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.PHONE */.hm.PHONE && leadInput.length === 10 && leadInput.match(phoneReg)) {
            dispatch((0,leadgen/* updateCustomerLead */.x6)(payload, callback));
        } else if (leadInput.match(emailReg)) dispatch((0,leadgen/* updateCustomerLead */.x6)(payload, callback));
        else setLeadError(true);
    };
    var renderError = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "error-msg flex f7 red flex justify-start items-center mt2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "ba b--red flex justify-center items-center br-pill bg-red white mr2 error-icon",
                    style: {
                        fontSize: 8,
                        padding: "2px 6px"
                    },
                    children: [
                        " ",
                        "!",
                        " "
                    ]
                }),
                "Please enter a valid ".concat((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL ? "email ID" : "phone number")
            ]
        });
    };
    return !!storePhone && (leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.status) && !(0,localStorageFunctions/* getLeadData */.X5)() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "f6 mb2",
                children: "Subscribe for latest updates & offers"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-start items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        placeholder: "Enter ".concat((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL ? "Email" : "Phone Number"),
                        value: leadInput,
                        className: "f6 bg-white pv2 ph2 b--black-10 w-100 rm-input-num-arrows",
                        onChange: handleLeadInput,
                        type: "".concat((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL ? "email" : "number")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "bn pointer",
                        "aria-label": "Subscribe for latest offers",
                        style: {
                            backgroundColor: "".concat(sColor || (store === null || store === void 0 ? void 0 : (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color)),
                            borderRadius: "0px 4px 4px 0px",
                            padding: "9px 12px 8px 12px"
                        },
                        onClick: submitLeadInput,
                        disabled: isSubmitInTransit,
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardArrow, {
                                color: "#0000000"
                            })
                        ]
                    })
                ]
            }),
            leadError ? renderError() : null
        ]
    }) : null;
};
/* harmony default export */ var DesignSystem_SubscriberInput = (SubscriberInput);


/***/ }),

/***/ 901218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _util_arePropsEqual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(548729);
/* harmony import */ var _utils_getGoogleMapUrl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(448863);




function FooterMap2(props) {
    var ref, ref1, ref2, ref3, ref4;
    var storeData = props.storeData, _height = props.height, height = _height === void 0 ? "250" : _height;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loadMap = ref5[0], setLoadMap = ref5[1];
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setLoadMap(true);
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return function() {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);
    return !!(storeData === null || storeData === void 0 ? void 0 : storeData.address) && (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.address) === null || ref === void 0 ? void 0 : ref.visibility) === 1 && !!(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.address) === null || ref1 === void 0 ? void 0 : ref1.latitude) && !!(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.address) === null || ref2 === void 0 ? void 0 : ref2.longitude) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "Footer2__section",
        ref: containerRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            width: "100%",
            height: height,
            title: "Address",
            loading: "lazy",
            src: loadMap ? (0,_utils_getGoogleMapUrl__WEBPACK_IMPORTED_MODULE_2__/* .getGoogleMapUrl */ .D)(storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.address) === null || ref3 === void 0 ? void 0 : ref3.latitude, storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.address) === null || ref4 === void 0 ? void 0 : ref4.longitude) : ""
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(FooterMap2, _util_arePropsEqual__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z));


/***/ }),

/***/ 176364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sy": function() { return /* reexport */ FooterMap_FooterMap; },
  "oJ": function() { return /* reexport */ FooterMap2/* default */.Z; },
  "IA": function() { return /* reexport */ FooterMap_FooterMap3; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/FooterMap/util/arePropsEqual.js
var arePropsEqual = __webpack_require__(548729);
// EXTERNAL MODULE: ./src/utils/getGoogleMapUrl.js
var getGoogleMapUrl = __webpack_require__(448863);
;// CONCATENATED MODULE: ./src/components/FooterMap/FooterMap.js




var FooterMap = /*#__PURE__*/ react.memo(function FooterMap(props) {
    var ref, ref1, ref2, ref3, ref4;
    var storeData = props.storeData;
    var ref5 = (0,react.useState)(false), loadMap = ref5[0], setLoadMap = ref5[1];
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setLoadMap(true);
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return function() {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);
    return !!(storeData === null || storeData === void 0 ? void 0 : storeData.address) && (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.address) === null || ref === void 0 ? void 0 : ref.visibility) === 1 && !!(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.address) === null || ref1 === void 0 ? void 0 : ref1.latitude) && !!(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.address) === null || ref2 === void 0 ? void 0 : ref2.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: containerRef,
        style: {
            display: "flex",
            height: "100%",
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            width: "100%",
            height: "250",
            title: "Address",
            loading: "lazy",
            src: loadMap ? (0,getGoogleMapUrl/* getGoogleMapUrl */.D)(storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.address) === null || ref3 === void 0 ? void 0 : ref3.latitude, storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.address) === null || ref4 === void 0 ? void 0 : ref4.longitude) : ""
        })
    });
}, arePropsEqual/* default */.Z);
/* harmony default export */ var FooterMap_FooterMap = (FooterMap);

// EXTERNAL MODULE: ./src/components/FooterMap/FooterMap2.js
var FooterMap2 = __webpack_require__(901218);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/components/FooterMap/FooterMap3.js





function FooterMap3(props) {
    var _storeData = props.storeData, storeData = _storeData === void 0 ? {} : _storeData;
    var _address = storeData.address, address = _address === void 0 ? {} : _address;
    var ref = (0,react.useState)(false), loadMap = ref[0], setLoadMap = ref[1];
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setLoadMap(true);
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return function() {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);
    var addressVisibilityHidden = function(visibilityValue) {
        return (address === null || address === void 0 ? void 0 : address.visibility) === visibilityValue;
    };
    var onHover = function() {
        document.getElementById("mapFrame").style.filter = "brightness(100%)";
        document.getElementById("mapText").style.display = "none";
    };
    var onHoverLeave = function() {
        document.getElementById("mapFrame").style.filter = "brightness(40%)";
        document.getElementById("mapText").style.display = "block";
    };
    return addressVisibilityHidden(constants/* ADDRESS_VISIBILITY.VISIBLE */.lE.VISIBLE) && !!address && !!(address === null || address === void 0 ? void 0 : address.latitude) && !!(address === null || address === void 0 ? void 0 : address.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: containerRef,
        className: "Footer3__map-section",
        onMouseEnter: onHover,
        onMouseLeave: onHoverLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                loading: "lazy",
                className: "map-frame",
                id: "mapFrame",
                width: "100%",
                height: "300px",
                title: "Address",
                src: loadMap ? (0,getGoogleMapUrl/* getGoogleMapUrl */.D)(address === null || address === void 0 ? void 0 : address.latitude, address === null || address === void 0 ? void 0 : address.longitude) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "map-text",
                id: "mapText",
                children: "Find us here"
            })
        ]
    });
}
/* harmony default export */ var FooterMap_FooterMap3 = (/*#__PURE__*/react.memo(FooterMap3, arePropsEqual/* default */.Z));

;// CONCATENATED MODULE: ./src/components/FooterMap/index.js





/***/ }),

/***/ 548729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ arePropsEqual; }
/* harmony export */ });
function arePropsEqual(prevProps, nextProps) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return ((ref = prevProps.storeData) === null || ref === void 0 ? void 0 : ref.address) === ((ref1 = nextProps.storeData) === null || ref1 === void 0 ? void 0 : ref1.address) && ((ref2 = prevProps.storeData) === null || ref2 === void 0 ? void 0 : ref2.latitude) === ((ref3 = nextProps.storeData) === null || ref3 === void 0 ? void 0 : ref3.latitude) && ((ref4 = prevProps.storeData) === null || ref4 === void 0 ? void 0 : ref4.longitude) === ((ref5 = nextProps.storeData) === null || ref5 === void 0 ? void 0 : ref5.longitude);
}


/***/ }),

/***/ 273323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(268037);
/* harmony import */ var _utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273494);


/**
 * use this hook to get info about store logo and store name visibility in Header and Footer.
 * visibility is defined by merchant by using editor.
 */ var useStoreLogoOrNameVisibility = function() {
    var ref = (0,_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store.theme || {};
    }), _store_logo_status = ref.store_logo_status, store_logo_status = _store_logo_status === void 0 ? false : _store_logo_status, _store_name_status = ref.store_name_status, store_name_status = _store_name_status === void 0 ? false : _store_name_status;
    return {
        isStoreLogoInHeader: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForHeader */ .g)(store_logo_status),
        isStoreLogoInFooter: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForFooter */ .S)(store_logo_status),
        isStoreNameInHeader: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForHeader */ .g)(store_name_status),
        isStoreNameInFooter: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForFooter */ .S)(store_name_status)
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useStoreLogoOrNameVisibility);


/***/ }),

/***/ 220949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(115483);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(506337);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(913886);
/* harmony import */ var _getUrlParams__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(705492);




var checkIfShowDummyProduts = function(storeData) {
    var isPreview = (0,_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var isPremium = !!storeData.premium;
    var items_available = (!_checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6 && (0,_getUrlParams__WEBPACK_IMPORTED_MODULE_3__/* .getUrlParams */ .D)([
        _constants__WEBPACK_IMPORTED_MODULE_2__/* .PREVIEW_PARAMS.ITEMS_AVAILABLE */ .I.ITEMS_AVAILABLE
    ])).items_available;
    var isItemsAvailable = +items_available;
    return isPreview && (!isPremium || !isItemsAvailable);
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfShowDummyProduts);


/***/ }),

/***/ 13605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ commonToggleAuthModal; }
/* harmony export */ });
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(540190);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


/**
 * common function to initiate auth toggle
 * @param {*} param0
 * @return {boolean} return
 */ var commonToggleAuthModal = function(param) {
    var userLogin = param.userLogin, storeInfoDomain = param.storeInfoDomain;
    if (userLogin) {
        return true;
    } else {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_0__.getRoute)(_routes__WEBPACK_IMPORTED_MODULE_0__.PATH.ORDERS, storeInfoDomain));
    }
    return false;
};


/***/ }),

/***/ 168491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(220949);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);


/**
 * function to get store logo in case of dummy or actual data
 * @param storeInfo
 * @returns
 */ var getActualOrDsStoreLogo = function(storeInfo) {
    var ref;
    var showDummyData = (0,_checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(storeInfo);
    return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.logo_image) || (showDummyData ? _constants__WEBPACK_IMPORTED_MODULE_1__/* .DS_LOGO_IMAGE_URL */ .pP : null);
};
/* harmony default export */ __webpack_exports__["Z"] = (getActualOrDsStoreLogo);


/***/ }),

/***/ 448863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getGoogleMapUrl; }
/* harmony export */ });
var getGoogleMapUrl = function(latitude, longitude) {
    return "https://www.google.com/maps/embed/v1/place?key=".concat("AIzaSyAVC1rp28LPP-kwCwVPZpZEt5LqLNYXVS8", "&q=").concat(latitude, ",").concat(longitude);
};


/***/ }),

/***/ 27909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ handleRouteChangesOnClick; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17247);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(540190);



var handleRouteChangesOnClick = function(routePath) {
    var additionalQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
        pathname: (0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)(routePath, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain),
        query: additionalQuery
    });
};


/***/ }),

/***/ 273494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getVisibilityForFooter; },
/* harmony export */   "g": function() { return /* binding */ getVisibilityForHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(629815);
// the status defines the visibility of logo or name with respect to header and footer

var STATUS_DISABLED = 0;
var STATUS_SHOW_ON_HEADER = 1;
var STATUS_SHOW_ON_FOOTER = 2;
var STATUS_SHOW_ON_HEADER_FOOTER = 3;
// const STATUS_DONT_SHOW_ON_HEADER_FOOTER = 4;
var COMMON_STATUS_SHOW = [
    STATUS_DISABLED,
    STATUS_SHOW_ON_HEADER_FOOTER
];
function getVisibilityForHeader(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_HEADER
    ]).includes(status);
}
function getVisibilityForFooter(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_FOOTER
    ]).includes(status);
}


/***/ }),

/***/ 295218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ removeDsAdsRouteLink; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);

function removeDsAdsRouteLink() {
    window.open(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT_DS_ADS_LINK.COMMON_REDIRECTION_LINK */ .gr.COMMON_REDIRECTION_LINK, "_blank");
}


/***/ }),

/***/ 695288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ validateEmailError; }
/* harmony export */ });
/* harmony import */ var _components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40804);

function validateEmailError(mail) {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(mail)) {
        (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__/* .toastNotifyError */ .Lu)("Invalid Email Id");
        return false;
    }
    return true;
}


/***/ }),

/***/ 186438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bottom_section":"FooterStorePolicies_bottom_section__Q64j2","footer__bottom-text":"FooterStorePolicies_footer__bottom-text__Cfylc","policy-nav":"FooterStorePolicies_policy-nav__u8EJg","store_policies":"FooterStorePolicies_store_policies__hE_9r","footer_nav":"FooterStorePolicies_footer_nav__DLmtJ"};

/***/ })

}]);